// extracted by mini-css-extract-plugin
export default {"toastLink":"styles_toastLink__49DVE"};